import React from 'react'
import { MultiValue } from 'react-select'
import Select from 'react-select'

import { Food } from '../../../core/foods'

interface SelectOption {
  value: string
  label: string
}

interface Props {
  foods: Food[]
  selectedFoodId: string
  onFoodChange: (foodId: string) => void
}

const FoodSelector: React.FC<Props> = ({
  foods,
  selectedFoodId,
  onFoodChange,
}) => {
  // ID順でソートしてオプション作成
  const foodOptions: SelectOption[] = [...foods]
    .sort((a, b) => a.id - b.id)
    .map(food => ({
      value: food.id.toString(),
      label: `ID: ${food.id} ${food.name || ''}`,
    }))

  // 「すべてのフード」オプションを先頭に追加
  const allOptions: SelectOption[] = [
    { value: '', label: 'すべてのフード' },
    ...foodOptions,
  ]

  const handleFoodChange = (option: SelectOption | MultiValue<SelectOption>) => {
    if (!Array.isArray(option)) {
      const singleOption = option as SelectOption | null
      if (singleOption) {
        onFoodChange(singleOption.value)
      } else {
        onFoodChange('')
      }
    }
  }

  const selectedValue =
    allOptions.find(option => option.value === selectedFoodId) || allOptions[0]

  const selectStyles = {
    control: (baseStyles: any) => ({
      ...baseStyles,
      width: '23.2rem',
      minHeight: '4.8rem',
      height: '4.8rem',
      padding: '0',
      fontSize: '1.6rem',
      fontWeight: '400',
      color: '#2c3e50',
      cursor: 'pointer',
      backgroundColor: '#fff',
      borderRadius: '0.4rem',
      border: 'none',
      boxShadow: '0 0 1rem rgba(0, 0, 0, 0.1)',
      transition: 'box-shadow 0.2s ease',
      '&:hover': {
        boxShadow: 'none',
      },
    }),
    valueContainer: (baseStyles: any) => ({
      ...baseStyles,
      height: '4.8rem',
      padding: '0 0.8rem 0 1.6rem',
    }),
    input: (baseStyles: any) => ({
      ...baseStyles,
      margin: '0',
      padding: '0',
      fontSize: '1.6rem',
    }),
    placeholder: (baseStyles: any) => ({
      ...baseStyles,
      color: '#95a5a6',
      fontSize: '1.6rem',
    }),
    singleValue: (baseStyles: any) => ({
      ...baseStyles,
      color: '#2c3e50',
      fontSize: '1.6rem',
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    dropdownIndicator: (baseStyles: any) => ({
      ...baseStyles,
      padding: '0.8rem',
      color: '#95a5a6',
    }),
    menu: (baseStyles: any) => ({
      ...baseStyles,
      borderRadius: '0.4rem',
      boxShadow: '0 0 1rem rgba(0, 0, 0, 0.1)',
    }),
    menuPortal: (baseStyles: any) => ({
      ...baseStyles,
      zIndex: 9999,
    }),
    menuList: (baseStyles: any) => ({
      ...baseStyles,
      padding: '0',
      maxHeight: '30rem',
    }),
    option: (baseStyles: any, state: any) => ({
      ...baseStyles,
      fontSize: '1.4rem',
      padding: '0.8rem 1.2rem',
      backgroundColor: state.isSelected
        ? '#3498db'
        : state.isFocused
        ? '#ecf0f1'
        : 'white',
      color: state.isSelected ? 'white' : '#2c3e50',
      cursor: 'pointer',
      '&:active': {
        backgroundColor: '#3498db',
      },
    }),
  }

  return (
    <Select
      options={allOptions}
      onChange={handleFoodChange}
      value={selectedValue}
      isMulti={false}
      isSearchable={true}
      placeholder="フードを選択"
      styles={selectStyles}
      menuPortalTarget={document.body}
      menuPosition="fixed"
      menuPlacement="auto"
    />
  )
}

export default FoodSelector
